import { render, staticRenderFns } from "./PropertiesModule.vue?vue&type=template&id=cf490ef0&scoped=true"
import script from "./PropertiesModule.vue?vue&type=script&lang=js"
export * from "./PropertiesModule.vue?vue&type=script&lang=js"
import style0 from "./PropertiesModule.vue?vue&type=style&index=0&id=cf490ef0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf490ef0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cf490ef0')) {
      api.createRecord('cf490ef0', component.options)
    } else {
      api.reload('cf490ef0', component.options)
    }
    module.hot.accept("./PropertiesModule.vue?vue&type=template&id=cf490ef0&scoped=true", function () {
      api.rerender('cf490ef0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/EditorControl/PropertiesModule.vue"
export default component.exports